// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgMultiBubble = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M7.5 10.25a6.25 6.25 0 1 1-2.872 11.8l-2.216.412a.75.75 0 0 1-.874-.874l.412-2.217A6.25 6.25 0 0 1 7.5 10.25m0 1.5a4.75 4.75 0 0 0-4.115 7.124c.09.155.12.338.088.514l-.261 1.4 1.4-.26.133-.013q.135 0 .26.044l.121.056.267.143A4.75 4.75 0 1 0 7.5 11.75M14 1.25a8.75 8.75 0 0 1 7.717 12.878l.62 3.335a.75.75 0 0 1-.874.874l-3.336-.621a8.7 8.7 0 0 1-2.726.923.75.75 0 0 1-.238-1.482 7.2 7.2 0 0 0 2.461-.877.75.75 0 0 1 .514-.088l2.525.47-.47-2.524a.75.75 0 0 1 .087-.514A7.25 7.25 0 1 0 6.824 8.956a.75.75 0 0 1-1.484-.214C5.95 4.506 9.594 1.25 14 1.25"
    />
  </svg>
);
export const MultiBubbleIcon = forwardRef(SvgMultiBubble);
